import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { SurveyDetails } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';

const newGenericGrid = new GenericGridCreator(
  'INTERNAL_JOBS',
  {},
  {
    defaultLeftColumns: [
      {
        Header: 'Survey Job Matches',
        stickyLeft: true,
        customRender: SurveyDetails,
        width: 350,
        accessor: null
      }
    ],
    hiddenTerms: ['field_survey_code', 'field_job_code', 'field_job_scope', 'field_pub_survey_long_name']
  },
  {
    getInstanceState: store => store.landingPage.InternalJobsReducer.internalJobsGrid
  }
);
export const internalJobsGridActions = newGenericGrid.getActions();

export default newGenericGrid.createReducer();
